import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import EmptyState from "@/components/base/EmptyState";
import { recommendations } from "@/mocks/content";

export default function RecommendSidebar() {
  return (
    <section className="rounded-lg border border-background-300 bg-background-50 p-5">
      <SectionTitle title="相关推荐" subtitle="你可能也喜欢的内容专题" />
      {recommendations.length === 0 ? (
        <EmptyState message="暂无最新内容，敬请期待" icon="ri-film-line" />
      ) : (
        <div className="flex flex-col gap-3">
          {recommendations.map((item) => (
            <Link
              key={item.id}
              to={item.link}
              className="group flex items-center gap-3 rounded-md border border-background-200 p-2.5 transition-colors hover:border-primary-300 hover:bg-primary-50/40"
            >
              <div className="h-20 w-14 shrink-0 overflow-hidden rounded-md">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={`${item.title} - 相关影视推荐`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-700">
                  {item.title}
                </h3>
                <p className="mt-1 line-clamp-2 text-xs text-foreground-500">
                  {item.subtitle}
                </p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}